import { useState, useCallback } from 'react'
import { useSectionController } from '@sevenrooms/ui-kit/layout'
import { AccordionTextInput } from './AccordionInput'

export interface GuestOtherInfoInputProps {
  title: string
  sectionName: string
  onSave: (value?: string) => Promise<boolean>
  saveText: string
  infoText?: string
  'data-test'?: string
}

export function GuestOtherInfoInput({ infoText, sectionName, onSave, ...props }: GuestOtherInfoInputProps) {
  const { tryToggleCollapse, collapsed } = useSectionController(sectionName, { initiallyCollapsed: true })
  const [inputInfo, setInputInfo] = useState(infoText)
  const [baseInfoValue, setBaseInfoValue] = useState(infoText)
  const onAccordionTextSave = useCallback(
    async (newValue?: string) => {
      const success = await onSave(newValue)
      setBaseInfoValue(newValue)
      return success
    },
    [onSave]
  )
  return (
    <AccordionTextInput
      isDirty={inputInfo !== baseInfoValue}
      onChange={setInputInfo}
      value={inputInfo}
      onSave={onAccordionTextSave}
      collapsed={collapsed}
      onToggle={tryToggleCollapse}
      {...props}
    />
  )
}
